import pic1 from "../images/pic1.png";
import pic2 from "../images/pic2.png";
import pic3 from "../images/pic3.png";
import pic4 from "../images/pic4.png";
import pic5 from "../images/pic5.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Aos from "aos";
import { useEffect, useState } from "react";
import "aos/dist/aos.css";
import axios from "axios";
export default function Testimonials() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    cssEase: "linear"

  };

  const data = [
    {
      name: "Arman Malik",
      img: pic1,
    },
    {
      name: "Shaily",
      img: pic2,
    },
    {
      name: "John Doe",
      img: pic3,
    },
    {
      name: "Annie",
      img: pic4,
    },
    {
      name: "Taylor",
      img: pic5,
    },
  ];

  const [clientData, setClientData] = useState([])
  const fetchClient = async() =>{
    const {data} = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/api/client`)
    setClientData(data)
  }
  useEffect(() => {
    Aos.init({ duration: 2000 });
    fetchClient()
  }, []);
  return (
    <div data-aos="fade-up" className="px-10 py-8 h-[550px] my-10">
      <div>
        <h1 className="sm:text-5xl text-3xl font-bold text-center w-full">Testimonials</h1>
        <p className="text-slate-400 text-center sm:text-lg text-base my-2">
          See what our client say
        </p>
        <Slider {...settings}>
          {clientData.map((item) => {
            return (
              <div className="bg-white h-[400px] w-[400px] p-5 rounded-lg flex items-center justify-center carousel_div">
                <img className="rounded-full" src={item.image} alt="" />
                <div className="flex flex-col justify-center items-center">
                  <h1 className="text-2xl font-bold mt-2">{item.name}</h1>
                  <p className="text-gray-700 text-center">
                    {item.message}
                  </p>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
